import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.CENTER};

const path = "center/dashboard"


export const Counts = async () => {
    return await axiosInstance(options).get(`${path}/counts`);
}
// export const Appointments = async (value) => {
//     return await axiosInstance(options).post(`${path}/list-appointments`, value);
// }


